import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CardV2, Heading, Text } from '@feathr/components';

import type { TConversionKind } from '../../ReportsConversionsGoalManagerPage.hooks';

import * as styles from './GoalDetailEmpty.css';

interface IGoalDetailEmptyProps {
  dashboardUrl: string;
  kind: TConversionKind;
  trackedOnCount: number;
}

function GoalDetailEmpty({
  dashboardUrl,
  kind,
  trackedOnCount,
}: Readonly<IGoalDetailEmptyProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <CardV2 contentClassName={styles.root} name={'goal-detail-empty'} width={'wide'}>
      <CardV2.Content padding={'relaxed'}>
        <Flex align={'center'} direction={'column'} gap={theme.spacing['4']}>
          <Heading order={3} variant={'h3'}>
            {t('No conversions yet')}
          </Heading>
          <Text.DefaultRegular>
            {kind === 'campaign'
              ? t(
                  "This goal is tracked across {{count}} active campaigns. Conversions will appear here as they're recorded.",
                  { count: trackedOnCount },
                )
              : t(
                  "This goal is tracked across {{count}} active flights. Conversions will appear here as they're recorded.",
                  { count: trackedOnCount },
                )}
          </Text.DefaultRegular>
          <Button link={dashboardUrl} type={'secondary'}>
            {t('View dashboard')}
          </Button>
        </Flex>
      </CardV2.Content>
    </CardV2>
  );
}

export default observer(GoalDetailEmpty);
